<template>
    <v-container fluid>
        <template v-if="isVerified">
            <v-row dense class="d-flex justify-center align-center">
                <v-col cols="12" md="4"> </v-col>
                <v-col cols="12" md="4" class="text-center pa-0 ma-0">
                    <img :src="publicPath + 'login_logo_azara.png'" style="width: 209.5px; height: auto" />
                </v-col>
                <v-col cols="12" md="4" class="text-left pl-4 d-none d-md-block">
                    <v-btn
                        style="border-radius: 8px"
                        color="#0da6b1"
                        class=".d-sm-block white--text text-none font-weight-bold pa-6 buttons-font"
                        @click="redirect"
                    >
                        {{ $t('buttons.backToWebsite') }}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="4" class="pl-1 pr-3 d-md-none">
                    <v-btn
                        style="border-radius: 8px"
                        block
                        color="#0da6b1"
                        class=".d-sm-block white--text text-none font-weight-bold buttons-font"
                        @click="redirect"
                    >
                        {{ $t('buttons.backToWebsite') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" class="text-center text-h6 font-weight-bold pt-2 headings-font headings-font-weight">
                    {{ $t('texts.applicationFor') }}
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" class="text-center text-h3 pb-4 pt-4 headings-font rank-font-weight">
                    {{ rank }}
                </v-col>
            </v-row>
            <v-row dense v-if="existingSeafarer">
                <v-col cols="12" md="4"> </v-col>
                <v-col cols="12" md="4">
                    <v-row dense class="pb-6">
                        <v-col cols="12" class="text-center text-h6 description-font">
                            {{ $t('texts.openApplicationExistingSeafarerText') }}
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" md="6" v-if="$vuetify.breakpoint.mobile">
                            <v-row dense>
                                <v-col cols="12">
                                    <InputField
                                        :disabled="true"
                                        v-model="application.name"
                                        :errorBorder="!applicationValidation.name"
                                        :label="$t('fields.name')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :disabled="true"
                                        v-model="application.surname"
                                        :errorBorder="!applicationValidation.surname"
                                        :label="$t('fields.surname')"
                                    ></InputField>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6" v-else>
                            <v-row dense>
                                <v-col cols="12">
                                    <InputField
                                        :disabled="true"
                                        v-model="application.name"
                                        :errorBorder="!applicationValidation.name"
                                        :label="$t('fields.name')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :disabled="true"
                                        v-model="application.phone"
                                        :errorBorder="!applicationValidation.phone"
                                        :label="$t('fields.phone')"
                                    ></InputField>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6" v-if="$vuetify.breakpoint.mobile">
                            <v-row dense>
                                <v-col cols="12">
                                    <InputField
                                        :disabled="true"
                                        v-model="application.phone"
                                        :errorBorder="!applicationValidation.phone"
                                        :label="$t('fields.phone')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :disabled="true"
                                        v-model="application.seafarer_book"
                                        :errorBorder="!applicationValidation.seafarer_book"
                                        :label="$t('fields.seamanBook')"
                                    ></InputField>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6" v-else>
                            <v-row dense>
                                <v-col cols="12">
                                    <InputField
                                        :disabled="true"
                                        v-model="application.surname"
                                        :errorBorder="!applicationValidation.surname"
                                        :label="$t('fields.surname')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :disabled="true"
                                        v-model="application.seafarer_book"
                                        :errorBorder="!applicationValidation.seafarer_book"
                                        :label="$t('fields.seamanBook')"
                                    ></InputField>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12">
                            <Dropdown
                                :disabled="true"
                                v-model="application.nationality_id"
                                :ajax="true"
                                :data="'web-application-nationalities/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.nationality_id"
                                :label="$t('fields.nationality')"
                                @load-error="handleDropdownLoadError"
                            ></Dropdown>
                        </v-col>
                        <v-col cols="12">
                            <Dropdown
                                :disabled="true"
                                v-model="application.rank_id"
                                :ajax="true"
                                :data="'web-application-ranks/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.rank_id"
                                :label="$t('fields.rank')"
                                @load-error="handleDropdownLoadError"
                            ></Dropdown>
                        </v-col>
                        <v-col cols="12">
                            <TextArea
                                v-model="application.status_notes"
                                :errorBorder="!applicationValidation.status_notes"
                                :label="$t('fields.notes')"
                            ></TextArea>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-center align-center">
                        <v-col class="text-center">
                            <v-btn
                                class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                color="#f6bb14"
                                style="border-radius: 8px"
                                :loading="saving"
                                @click="saveClick"
                            >
                                {{ $t('buttons.submit') }}
                            </v-btn>
                        </v-col>
                        <v-col class="text-center">
                            <v-btn
                                class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                color="#0da6b1"
                                style="border-radius: 8px"
                                :loading="canceling"
                                @click="cancelClick"
                            >
                                {{ $t('buttons.cancel') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="4"> </v-col>
            </v-row>
            <v-row dense v-else>
                <v-col cols="12" md="4"> </v-col>
                <v-col cols="12" md="4">
                    <v-row dense class="pb-6">
                        <v-col cols="12" class="text-center text-h6 description-font">
                            {{ $t('texts.defaultApplicationText') }}
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" md="6" v-if="$vuetify.breakpoint.mobile">
                            <v-row dense>
                                <v-col cols="12">
                                    <InputField
                                        v-model="application.name"
                                        :errorBorder="!applicationValidation.name"
                                        :label="'* ' + $t('fields.name')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        v-model="application.surname"
                                        :errorBorder="!applicationValidation.surname"
                                        :label="'* ' + $t('fields.surname')"
                                    ></InputField>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6" v-else>
                            <v-row dense>
                                <v-col cols="12">
                                    <InputField
                                        v-model="application.name"
                                        :errorBorder="!applicationValidation.name"
                                        :label="'* ' + $t('fields.name')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        v-model="application.phone"
                                        :errorBorder="!applicationValidation.phone"
                                        :label="'* ' + $t('fields.phone')"
                                    ></InputField>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6" v-if="$vuetify.breakpoint.mobile">
                            <v-row dense>
                                <v-col cols="12">
                                    <InputField
                                        v-model="application.phone"
                                        :errorBorder="!applicationValidation.phone"
                                        :label="'* ' + $t('fields.phone')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        v-model="application.seafarer_book"
                                        :errorBorder="!applicationValidation.seafarer_book"
                                        :label="'* ' + $t('fields.seamanBook')"
                                    ></InputField>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6" v-else>
                            <v-row dense>
                                <v-col cols="12">
                                    <InputField
                                        v-model="application.surname"
                                        :errorBorder="!applicationValidation.surname"
                                        :label="'* ' + $t('fields.surname')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        v-model="application.seafarer_book"
                                        :errorBorder="!applicationValidation.seafarer_book"
                                        :label="'* ' + $t('fields.seamanBook')"
                                    ></InputField>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12">
                            <Dropdown
                                v-model="application.nationality_id"
                                :ajax="true"
                                :data="'web-application-nationalities/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.nationality_id"
                                :label="'* ' + $t('fields.nationality')"
                                @load-error="handleDropdownLoadError"
                            ></Dropdown>
                        </v-col>
                        <v-col cols="12">
                            <Upload
                                class="text-center"
                                v-model="application.candidate_resume"
                                :errorBorder="!applicationValidation.candidate_resume"
                                :label="'* ' + $t('fields.cv')"
                                @uploaded="increaseUploadCounter"
                                :isNavFile="true"
                            ></Upload>
                        </v-col>
                        <v-col cols="12">
                            <Dropdown
                                v-model="application.rank_id"
                                :ajax="true"
                                :data="'web-application-ranks/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.rank_id"
                                :label="'* ' + $t('fields.rank')"
                                @load-error="handleDropdownLoadError"
                            ></Dropdown>
                        </v-col>
                        <v-col cols="12">
                            <DropdownMultiple
                                v-model="application.vessels"
                                :ajax="true"
                                :data="'web-application-vessel-types/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.vessels"
                                :label="'* ' + $t('fields.vesselExp')"
                                @load-error="handleDropdownLoadError"
                            ></DropdownMultiple>
                        </v-col>
                        <v-col cols="12">
                            <TextArea
                                v-model="application.status_notes"
                                :errorBorder="!applicationValidation.status_notes"
                                :label="$t('fields.notes')"
                            ></TextArea>
                        </v-col>
                    </v-row>
                    <v-row
                        dense
                        v-if="fillOutFullApplicationClicked"
                        :key="'full-app-' + fillOutFullApplicationClicked"
                    >
                        <v-col cols="12">
                            <DatePicker
                                v-model="application.available_date"
                                :errorBorder="!applicationValidation.available_date"
                                :date-label="'* ' + $t('fields.availableDate')"
                            ></DatePicker>
                        </v-col>
                        <v-col cols="12">
                            <DatePicker
                                v-model="application.date_of_birth"
                                :errorBorder="!applicationValidation.date_of_birth"
                                :date-label="'* ' + $t('fields.dateOfBirth')"
                            ></DatePicker>
                        </v-col>
                        <v-col cols="12">
                            <InputField
                                v-model="application.oib"
                                :errorBorder="!applicationValidation.oib"
                                :label="$t('fields.nationalIdentifierOib')"
                            ></InputField>
                        </v-col>
                        <v-col cols="12">
                            <Dropdown
                                v-model="application.country_of_residency_id"
                                :ajax="true"
                                :data="'web-application-countries/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.country_of_residency_id"
                                :label="'* ' + $t('fields.countryOfResidency')"
                                @load-error="handleDropdownLoadError"
                            ></Dropdown>
                        </v-col>
                        <v-col cols="12">
                            <InputField
                                v-model="application.place_of_birth"
                                :errorBorder="!applicationValidation.place_of_birth"
                                :label="'* ' + $t('fields.placeOfBirth')"
                            ></InputField>
                        </v-col>
                        <v-col cols="12">
                            <Dropdown
                                v-model="application.gender_id"
                                :ajax="true"
                                :data="'web-application-genders/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.gender_id"
                                :label="'* ' + $t('fields.gender')"
                                @load-error="handleDropdownLoadError"
                            ></Dropdown>
                        </v-col>
                        <v-col cols="12">
                            <Dropdown
                                v-model="application.marital_status_id"
                                :ajax="true"
                                :data="'web-application-marital-statuses/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.marital_status_id"
                                :label="'* ' + $t('fields.maritalStatus')"
                                @load-error="handleDropdownLoadError"
                            ></Dropdown>
                        </v-col>
                        <v-col cols="12">
                            <Dropdown
                                v-model="application.account_currency_id"
                                :ajax="true"
                                :data="'web-application-currencies-with-exchange/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.account_currency_id"
                                :label="'* ' + $t('fields.accountCurrency')"
                                @load-error="handleDropdownLoadError"
                            ></Dropdown>
                        </v-col>
                        <v-col cols="12">
                            <InputField
                                v-model="application.street_name_and_number"
                                :errorBorder="!applicationValidation.street_name_and_number"
                                :label="'* ' + $t('fields.streetNameAndNumber')"
                            ></InputField>
                        </v-col>
                        <v-col cols="12">
                            <InputField
                                v-model="application.city"
                                :errorBorder="!applicationValidation.city"
                                :label="'* ' + $t('fields.city')"
                            ></InputField>
                        </v-col>
                        <v-col cols="12">
                            <InputField
                                v-model="application.post_code"
                                :errorBorder="!applicationValidation.post_code"
                                :label="'* ' + $t('fields.postCode')"
                            ></InputField>
                        </v-col>
                        <v-col cols="12">
                            <Dropdown
                                v-model="application.country_id"
                                :ajax="true"
                                :data="'web-application-countries/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.country_id"
                                :label="'* ' + $t('fields.country')"
                                @load-error="handleDropdownLoadError"
                            ></Dropdown>
                        </v-col>
                        <v-col cols="12">
                            <Dropdown
                                v-model="application.airport_id"
                                :ajax="true"
                                :data="'web-application-airports/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.airport_id"
                                :label="'* ' + $t('fields.airport')"
                                @load-error="handleDropdownLoadError"
                            ></Dropdown>
                        </v-col>
                        <v-col cols="12">
                            <InputField
                                v-model="application.emergency_contact_name"
                                :errorBorder="!applicationValidation.emergency_contact_name"
                                :label="'* ' + $t('fields.emergencyContactName')"
                            ></InputField>
                        </v-col>
                        <v-col cols="12">
                            <Dropdown
                                v-model="application.emergency_contact_relationship_id"
                                :ajax="true"
                                :data="'web-application-emergency-contact-relationship/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.emergency_contact_relationship_id"
                                :label="'* ' + $t('fields.emergencyContactRelationship')"
                                @load-error="handleDropdownLoadError"
                            ></Dropdown>
                        </v-col>
                        <v-col cols="12">
                            <InputField
                                v-model="application.emergency_contact_street_name_and_number"
                                :errorBorder="!applicationValidation.emergency_contact_street_name_and_number"
                                :label="'* ' + $t('fields.emergencyContactStreetNameAndNumber')"
                            ></InputField>
                        </v-col>
                        <v-col cols="12">
                            <InputField
                                v-model="application.emergency_contact_city"
                                :errorBorder="!applicationValidation.emergency_contact_city"
                                :label="'* ' + $t('fields.emergencyContactCity')"
                            ></InputField>
                        </v-col>
                        <v-col cols="12">
                            <InputField
                                v-model="application.emergency_contact_post_code"
                                :errorBorder="!applicationValidation.emergency_contact_post_code"
                                :label="'* ' + $t('fields.emergencyContactPostCode')"
                            ></InputField>
                        </v-col>
                        <v-col cols="12">
                            <Dropdown
                                v-model="application.emergency_contact_country_id"
                                :ajax="true"
                                :data="'web-application-countries/' + this.$route.params.token"
                                :errorBorder="!applicationValidation.emergency_contact_country_id"
                                :label="'* ' + $t('fields.emergencyContactCountry')"
                                @load-error="handleDropdownLoadError"
                            ></Dropdown>
                        </v-col>
                        <v-col cols="12">
                            <InputField
                                v-model="application.contact_number"
                                :errorBorder="!applicationValidation.contact_number"
                                :label="'* ' + $t('fields.emergencyContactNumber')"
                            ></InputField>
                        </v-col>
                        <v-col cols="12">
                            <InputField
                                v-model="application.contact_email"
                                :errorBorder="!applicationValidation.contact_email"
                                :label="'* ' + $t('fields.emergencyContactEmail')"
                            ></InputField>
                        </v-col>
                        <v-col cols="12">
                            <div style="width: 100%; overflow: auto">
                                <div style="width: 100%; float: right; text-align: left">
                                    <v-btn
                                        small
                                        class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                        color="#0da6b1"
                                        style="border-radius: 8px"
                                        @click="addEducation"
                                    >
                                        <v-icon small class="mr-2">fas fa-plus</v-icon>
                                        {{ $t('buttons.addEducation') }}
                                    </v-btn>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" v-if="educationItems.length > 0">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">{{ $t('fields.schoolName') }}</th>
                                            <th class="text-left">{{ $t('fields.from') }}</th>
                                            <th class="text-left">{{ $t('fields.to') }}</th>
                                            <th class="text-left">{{ $t('buttons.delete') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in educationItems" :key="index">
                                            <td>{{ item.school_name }}</td>
                                            <td class="pl-2">
                                                {{ item.date_from_display }}
                                            </td>
                                            <td>
                                                {{ item.date_to_display }}
                                            </td>
                                            <td class="pl-1">
                                                <v-btn
                                                    class="ml-2 mr-2 mt-1"
                                                    color="secondary"
                                                    @click="removeEducation(index)"
                                                >
                                                    <v-icon small>fa-trash</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                        <v-col cols="12">
                            <div style="width: 100%; overflow: auto">
                                <div style="width: 100%; float: right; text-align: left">
                                    <v-btn
                                        small
                                        class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                        color="#0da6b1"
                                        style="border-radius: 8px"
                                        @click="addLanguage"
                                    >
                                        <v-icon small class="mr-2">fas fa-plus</v-icon>
                                        {{ $t('buttons.addLanguage') }}
                                    </v-btn>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" v-if="languagesItems.length > 0">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">{{ $t('fields.language') }}</th>
                                            <th class="text-left">{{ $t('fields.rating') }}</th>
                                            <th class="text-left">{{ $t('fields.level') }}</th>
                                            <th class="text-left">{{ $t('buttons.delete') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in languagesItems" :key="index">
                                            <td>{{ item.language_display }}</td>
                                            <td class="pl-2">
                                                <v-rating
                                                    :readonly="true"
                                                    v-model="item.level"
                                                    color="primary"
                                                    background-color="grey darken-1"
                                                    length="4"
                                                    size="30"
                                                ></v-rating>
                                            </td>
                                            <td>
                                                {{ levelString(item.level) }}
                                            </td>
                                            <td class="pl-1">
                                                <v-btn
                                                    class="ml-2 mr-2 mt-1"
                                                    color="secondary"
                                                    @click="removeLanguage(index)"
                                                >
                                                    <v-icon small>fa-trash</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                        <v-col cols="12">
                            <div style="width: 100%; overflow: auto">
                                <div style="width: 100%; float: right; text-align: left">
                                    <v-btn
                                        small
                                        class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                        color="#0da6b1"
                                        style="border-radius: 8px"
                                        @click="addNavigation"
                                    >
                                        <v-icon small class="mr-2">fas fa-plus</v-icon>
                                        {{ $t('buttons.addSeaService') }}
                                    </v-btn>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <v-col
                                cols="12"
                                v-for="(item, index) in navigationItems"
                                :key="index"
                                style="padding: 0px; margin: 0px"
                            >
                                <v-card style="margin: 5px">
                                    <v-card-text>
                                        <div style="width: 100%; overflow: auto">
                                            <div style="width: 30%; float: left; font-weight: bold">
                                                {{ $t('fields.companyName') }}:
                                            </div>
                                            <div style="width: 70%; float: left">{{ item.entity_name }}</div>
                                            <div style="width: 30%; float: left; font-weight: bold">
                                                {{ $t('fields.rank') }}:
                                            </div>
                                            <div style="width: 70%; float: left">{{ item.rank_display }}</div>
                                            <div style="width: 30%; float: left; font-weight: bold">
                                                {{ $t('fields.vessel') }}:
                                            </div>
                                            <div style="width: 70%; float: left">{{ item.maritime_object_name }}</div>
                                            <div style="width: 30%; float: left; font-weight: bold">
                                                {{ $t('fields.signedOn') }}:
                                            </div>
                                            <div style="width: 70%; float: left">{{ item.signed_on_display }}</div>
                                            <div style="width: 30%; float: left; font-weight: bold">
                                                {{ $t('fields.signedOff') }}:
                                            </div>
                                            <div style="width: 70%; float: left">{{ item.signed_off_display }}</div>
                                            <div style="width: 30%; float: left; font-weight: bold">
                                                {{ $t('fields.duration') }}:
                                            </div>
                                            <div style="width: 70%; float: left">{{ item.duration }}</div>
                                            <div style="width: 50%; float: right; text-align: right">
                                                <v-btn
                                                    small
                                                    class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                                    color="secondary"
                                                    style="border-radius: 8px"
                                                    @click="removeNavigation(index)"
                                                >
                                                    <v-icon small class="mr-2">fas fa-trash</v-icon>
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-card-text></v-card
                                >
                            </v-col>
                        </v-col>
                        <v-col cols="12">
                            <div style="width: 100%; overflow: auto">
                                <div style="width: 100%; float: right; text-align: left">
                                    <v-btn
                                        small
                                        class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                        color="#0da6b1"
                                        style="border-radius: 8px"
                                        @click="addDocument"
                                    >
                                        <v-icon small class="mr-2">fas fa-plus</v-icon>
                                        {{ $t('buttons.addDocument') }}
                                    </v-btn>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <v-col
                                cols="12"
                                v-for="(item, index) in documentItems"
                                :key="index"
                                style="padding: 0px; margin: 0px"
                            >
                                <v-card style="margin: 5px">
                                    <v-card-text>
                                        <div style="width: 100%; overflow: auto">
                                            <div style="width: 30%; float: left; font-weight: bold">
                                                {{ $t('fields.documentType') }}:
                                            </div>
                                            <div style="width: 70%; float: left">{{ item.document_type_display }}</div>
                                            <div style="width: 30%; float: left; font-weight: bold">
                                                {{ $t('fields.documentName') }}:
                                            </div>
                                            <div style="width: 70%; float: left">{{ item.document_name_display }}</div>
                                            <div style="width: 30%; float: left; font-weight: bold">
                                                {{ $t('fields.issuingCountry') }}:
                                            </div>
                                            <div v-if="item.issuing_country_id != null" style="width: 70%; float: left">
                                                {{ item.issuing_country_display }}
                                            </div>
                                            <div v-else style="width: 70%; float: left">N/A</div>
                                            <div style="width: 30%; float: left; font-weight: bold">
                                                {{ $t('fields.issuedBy') }}:
                                            </div>
                                            <div v-if="item.issued_by != ''" style="width: 70%; float: left">
                                                {{ item.issued_by }}
                                            </div>
                                            <div v-else style="width: 70%; float: left">N/A</div>
                                            <div style="width: 30%; float: left; font-weight: bold">
                                                {{ $t('fields.documentNumber') }}:
                                            </div>
                                            <div v-if="item.document_number != ''" style="width: 70%; float: left">
                                                {{ item.document_number }}
                                            </div>
                                            <div v-else style="width: 70%; float: left">N/A</div>
                                            <div style="width: 30%; float: left; font-weight: bold">
                                                {{ $t('fields.dateIssued') }}:
                                            </div>
                                            <div v-if="item.date_issued != null" style="width: 70%; float: left">
                                                {{ item.date_issued_display }}
                                            </div>
                                            <div v-else style="width: 70%; float: left">N/A</div>
                                            <div style="width: 50%; float: right; text-align: right">
                                                <v-btn
                                                    small
                                                    class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                                    color="secondary"
                                                    style="border-radius: 8px"
                                                    @click="removeDocument(index)"
                                                >
                                                    {{ $t('buttons.removeDocument') }}
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-card-text></v-card
                                >
                            </v-col>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-center align-center" v-if="!fillOutFullApplicationClicked">
                        <v-col class="text-center">
                            <v-btn
                                class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                color="#0da6b1"
                                style="border-radius: 8px"
                                @click="clickFillOutFullApplication"
                            >
                                {{ $t('buttons.fillOutFullApplication') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-center align-center" v-else>
                        <v-col class="text-center">
                            <v-btn
                                class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                color="#0da6b1"
                                style="border-radius: 8px"
                                @click="clickFillOutFullApplication"
                            >
                                {{ $t('buttons.fillOutOnlyRequiredFields') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-center align-center" v-if="!fillOutFullApplicationClicked">
                        <v-col class="text-center">
                            <v-btn
                                class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                color="#f6bb14"
                                style="border-radius: 8px"
                                :loading="saving"
                                @click="saveClick"
                            >
                                {{ $t('buttons.submitShortApplication') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-center align-center" v-else>
                        <v-col class="text-center">
                            <v-btn
                                class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                color="#f6bb14"
                                style="border-radius: 8px"
                                :loading="saving"
                                @click="saveClick"
                            >
                                {{ $t('buttons.submitFullApplication') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-center align-center">
                        <v-col class="text-center description-font">
                            <v-btn
                                class="white--text ma-2 font-weight-bold buttons-font pa-6"
                                color="#0da6b1"
                                style="border-radius: 8px"
                                :loading="canceling"
                                @click="cancelClick"
                            >
                                {{ $t('buttons.cancel') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="4"> </v-col>
            </v-row>
        </template>
        <v-row>
            <v-col>
                <Modal :show-modal="showModal" :max-width="550">
                    <div class="text submit-text text-center pt-12 pb-16">
                        {{ modalText }}
                    </div>
                    <div class="text redirecting-text text-center pb-6">
                        {{ $t('texts.redirectingText') }}&nbsp;{{ countdown }}&nbsp;{{ $t('fields.seconds') }}...
                    </div>
                </Modal>
            </v-col>
        </v-row>
        <v-row>
            <v-dialog persistent v-model="addLanguageDialog" width="600">
                <v-card>
                    <v-card-title>
                        {{ $t('labels.newLanguage') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-row dense wrap>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="languageObject.language_id"
                                            :ajax="true"
                                            :data="'web-application-languages/' + this.$route.params.token"
                                            :errorBorder="!languageObjectValidation.language_id"
                                            :label="'* ' + $t('fields.language')"
                                            @selected="selectedLanguage"
                                            @load-error="handleDropdownLoadError"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="2">
                                        <div style="font-size: large; font-weight: bold; margin-top: 16px">
                                            {{ $t('labels.rating') }}
                                        </div>
                                    </v-col>
                                    <v-col cols="10">
                                        <v-rating
                                            :item-labels="['sad', '', '', '', 'happy']"
                                            v-model="languageObject.level"
                                            color="primary"
                                            background-color="grey darken-1"
                                            hover
                                            length="4"
                                            size="35"
                                        ></v-rating>
                                    </v-col>
                                    <v-col cols="2">
                                        <div style="font-size: large; font-weight: bold">{{ $t('labels.level') }}</div>
                                    </v-col>
                                    <v-col cols="10">
                                        <div style="font-size: large">{{ level }}</div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="6"
                                        class="text-right"
                                        :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                    >
                                        <v-btn color="primary" class="white--text" @click.stop="saveLanguage"
                                            >{{ $t('buttons.save') }}
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                        class="text-left"
                                        :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                    >
                                        <v-btn color="secondary" class="white--text" @click.stop="closeLanguageDialog"
                                            >{{ $t('buttons.cancel') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog persistent v-model="addEducationDialog" width="600">
                <v-card>
                    <v-card-title>
                        {{ $t('labels.newEducation') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-row dense wrap>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="educationObject.school_name"
                                            :errorBorder="!educationObjectValidation.school_name"
                                            :label="'* ' + $t('fields.schoolName')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <DatePicker
                                            v-model="educationObject.date_from"
                                            :errorBorder="!educationObjectValidation.date_from"
                                            :date-label="'* ' + $t('fields.from')"
                                        ></DatePicker>
                                    </v-col>
                                    <v-col cols="12">
                                        <DatePicker
                                            v-model="educationObject.date_to"
                                            :errorBorder="!educationObjectValidation.date_to"
                                            :date-label="'* ' + $t('fields.to')"
                                        ></DatePicker>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="6"
                                        class="text-right"
                                        :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                    >
                                        <v-btn color="primary" class="white--text" @click.stop="saveEducation"
                                            >{{ $t('buttons.save') }}
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                        class="text-left"
                                        :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                    >
                                        <v-btn color="secondary" class="white--text" @click.stop="closeEducationDialog"
                                            >{{ $t('buttons.cancel') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="addNavigationDialog" persistent width="700">
                <v-card>
                    <v-card-title>
                        {{ $t('labels.newSeaExperienceWithOtherCompanies') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="6">
                                <v-row dense wrap>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="navigationObject.entity_name"
                                            :errorBorder="!navigationObjectValidation.entity_name"
                                            :label="'* ' + $t('fields.companyName')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="navigationObject.rank_id"
                                            :errorBorder="!navigationObjectValidation.rank_id"
                                            :ajax="true"
                                            :data="'web-application-ranks/' + this.$route.params.token"
                                            :label="'* ' + $t('fields.rank')"
                                            @selected="selectedRank"
                                            @load-error="handleDropdownLoadError"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="navigationObject.maritime_object_name"
                                            :errorBorder="!navigationObjectValidation.maritime_object_name"
                                            :label="'* ' + $t('fields.vessel')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <DatePicker
                                            v-model="navigationObject.signed_on"
                                            :errorBorder="!navigationObjectValidation.signed_on"
                                            :date-label="'* ' + $t('fields.signedOn')"
                                        ></DatePicker>
                                    </v-col>
                                    <v-col cols="12">
                                        <DatePicker
                                            v-model="navigationObject.signed_off"
                                            :errorBorder="!navigationObjectValidation.signed_off"
                                            :date-label="'* ' + $t('fields.signedOff')"
                                        ></DatePicker>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :readonly="true"
                                            :maxlength="50"
                                            v-model="navigationObject.duration"
                                            :errorBorder="!navigationObjectValidation.duration"
                                            :label="'* ' + $t('fields.duration')"
                                        ></InputField>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="6">
                                <v-row dense wrap>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="navigationObject.vessel_type_id"
                                            :errorBorder="!navigationObjectValidation.vessel_type_id"
                                            :ajax="true"
                                            :data="'web-application-vessel-types/' + this.$route.params.token"
                                            :label="$t('fields.typeOfVessel')"
                                            @load-error="handleDropdownLoadError"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="navigationObject.dwt"
                                            :errorBorder="!navigationObjectValidation.dwt"
                                            :label="$t('fields.dwt')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="navigationObject.gt"
                                            :errorBorder="!navigationObjectValidation.gt"
                                            :label="$t('fields.gt')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="navigationObject.engine_type_id"
                                            :errorBorder="!navigationObjectValidation.engine_type_id"
                                            :ajax="true"
                                            :data="'web-application-engine-types/' + this.$route.params.token"
                                            :label="$t('fields.engineType')"
                                            @load-error="handleDropdownLoadError"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :maxlength="50"
                                            v-model="navigationObject.kw"
                                            :errorBorder="!navigationObjectValidation.kw"
                                            :label="$t('fields.kW')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="navigationObject.dp_manufacturer_id"
                                            :errorBorder="!navigationObjectValidation.dp_manufacturer_id"
                                            :ajax="true"
                                            :data="'web-application-dp-manufacturers/' + this.$route.params.token"
                                            :label="$t('fields.dpManufacturer')"
                                            @load-error="handleDropdownLoadError"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            v-model="navigationObject.dp_type_id"
                                            :errorBorder="!navigationObjectValidation.dp_type_id"
                                            :ajax="true"
                                            :data="'web-application-dp-types/' + this.$route.params.token"
                                            :label="$t('fields.dpType')"
                                            @load-error="handleDropdownLoadError"
                                        ></Dropdown>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                                class="text-right"
                                :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                            >
                                <v-btn color="primary" class="white--text" @click.stop="saveNavigation()"
                                    >{{ $t('buttons.save') }}
                                </v-btn>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                                class="text-left"
                                :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                            >
                                <v-btn color="secondary" class="white--text" @click.stop="closeNavigationDialog()"
                                    >{{ $t('buttons.cancel') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <v-dialog persistent v-model="addDocumentDialog" width="600">
            <v-card>
                <v-card-title>
                    {{ $t('labels.newDocument') }}
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-row dense wrap>
                                <v-col cols="12">
                                    <Dropdown
                                        :ajax="true"
                                        :data="'web-application-document-categories/' + this.$route.params.token"
                                        :label="'* ' + $t('fields.type')"
                                        @input="reloadDocumentTypes"
                                        v-model="typeId"
                                        @selected="selectedCategory"
                                        @load-error="handleDropdownLoadError"
                                    ></Dropdown>
                                </v-col>
                                <v-col cols="12">
                                    <Dropdown
                                        v-model="documentObject.document_type_id"
                                        :ajax="false"
                                        :data="documentTypes"
                                        :errorBorder="!documentObjectValidation.document_type_id"
                                        :label="'* ' + $t('fields.documentName')"
                                        :key="componentKey"
                                        @selected="selectedType"
                                        @load-error="handleDropdownLoadError"
                                    ></Dropdown>
                                </v-col>
                                <v-col cols="12">
                                    <Dropdown
                                        v-model="documentObject.issuing_country_id"
                                        :ajax="true"
                                        :data="'web-application-countries/' + this.$route.params.token"
                                        :errorBorder="!documentObjectValidation.issuing_country_id"
                                        :label="$t('fields.issuingCountry')"
                                        @selected="selectedCountry"
                                        @load-error="handleDropdownLoadError"
                                    ></Dropdown>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        v-model="documentObject.issued_by"
                                        :errorBorder="!documentObjectValidation.issued_by"
                                        :label="$t('fields.issuedBy')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        v-model="documentObject.document_number"
                                        :errorBorder="!documentObjectValidation.document_number"
                                        :label="$t('fields.documentNumber')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <DatePicker
                                        v-model="documentObject.date_issued"
                                        :errorBorder="!documentObjectValidation.date_issued"
                                        :date-label="$t('fields.dateIssued')"
                                    ></DatePicker>
                                </v-col>
                                <v-col cols="12" class="pt-4 pb-0 mb-0">
                                    {{ $t('labels.validity') }}
                                </v-col>
                                <v-col cols="12" v-if="expirationTypesLoaded" class="pt-0 mt-0">
                                    <v-radio-group
                                        v-model="documentObject.document_expiration_type_id"
                                        row
                                        class="pt-2 mt-0"
                                    >
                                        <v-radio
                                            v-for="(item, key) in documentExpirationTypes"
                                            :key="key"
                                            :label="item.name"
                                            :value="item.id"
                                            color="primary"
                                            style="margin: auto"
                                        >
                                        </v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="12" v-if="documentObject.document_expiration_type_id">
                                    <DatePicker
                                        :disabled="isDateOfExpiryDisabled"
                                        :readonly="isDateOfExpiryDisabled"
                                        v-model="documentObject.date_of_expiry"
                                        :errorBorder="!documentObjectValidation.date_of_expiry"
                                        :date-label="$t('fields.dateOfExpiry')"
                                    ></DatePicker>
                                </v-col>
                                <v-col cols="12">
                                    <Upload
                                        v-model="documentObject.uploaded_file"
                                        :errorBorder="!documentObjectValidation.uploaded_file"
                                        :isNavFile="false"
                                    ></Upload>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                    cols="12"
                                    md="6"
                                    class="text-right"
                                    :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                >
                                    <v-btn
                                        color="primary"
                                        class="white--text"
                                        :disabled="!expirationTypesLoaded"
                                        @click.stop="saveDocument"
                                        >{{ $t('buttons.save') }}
                                    </v-btn>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6"
                                    class="text-left"
                                    :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                >
                                    <v-btn color="secondary" class="white--text" @click.stop="closeDocumentDialog"
                                        >{{ $t('buttons.cancel') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Modal from '../../trinkets/Modal.vue';
import InputField from '../../trinkets/InputField.vue';
import DatePicker from '../../trinkets/DatePicker';
import Dropdown from '../../trinkets/Dropdown.vue';
import DropdownMultiple from '../../trinkets/DropdownMultiple.vue';
import TextArea from '../../trinkets/TextArea.vue';
import Upload from '../../trinkets/Upload.vue';
import Application from '../../../models/Application.js';
import ApplicationLanguage from '../../../models/ApplicationLanguage.js';
import Education from '../../../models/Education.js';
import ApplicationNavigation from '../../../models/ApplicationNavigation.js';
import ApplicationSeafarerDocument from '../../../models/ApplicationSeafarerDocument.js';

export default {
    name: 'VacancyApplication',
    components: {Modal, InputField, TextArea, Dropdown, DropdownMultiple, Upload, DatePicker},
    data: function () {
        return {
            application: new Application({vacancy_id: this.$route.params.vacancyId}),
            applicationValidation: new Application({}, true),
            publicPath: process.env.BASE_URL,
            showModal: false,
            saving: false,
            canceling: false,
            countdown: 5,
            uploadCounter: 0,
            rank: '',
            modalText: '',
            isVerified: false,
            fillOutFullApplicationClicked: false,
            languagesItems: [],
            languageObject: new ApplicationLanguage({}),
            languageObjectValidation: new ApplicationLanguage({}, true),
            addLanguageDialog: false,
            educationItems: [],
            educationObject: new Education({}),
            educationObjectValidation: new Education({}, true),
            addEducationDialog: false,
            navigationItems: [],
            navigationObject: new ApplicationNavigation({}),
            navigationObjectValidation: new ApplicationNavigation({}, true),
            addNavigationDialog: false,
            documentItems: [],
            documentObject: new ApplicationSeafarerDocument({}),
            documentObjectValidation: new ApplicationSeafarerDocument({}, true),
            addDocumentDialog: false,
            typeId: null,
            documentTypes: [],
            componentKey: 0,
            expirationTypesLoaded: false,
            documentExpirationTypes: [],
        };
    },
    watch: {
        'navigationObject.signed_on': {
            handler: function () {
                this.calculateDuration();
            },
            deep: true,
        },
        'navigationObject.signed_off': {
            handler: function () {
                this.calculateDuration();
            },
            deep: true,
        },
        'addDocumentDialog'(newVal) {
            if (newVal) {
                this.loadExpiraitonTypes();
            }
        },
        'documentObject.date_issued': {
            handler: function () {
                if (this.documentObject.date_issued != null && this.documentObject.date_of_expiry != null) {
                    const dateIssued = new Date(this.documentObject.date_issued);
                    const dateOfExpiry = new Date(this.documentObject.date_of_expiry);
                    if (dateIssued > dateOfExpiry) {
                        this.documentObjectValidation.date_issued = false;
                        this.documentObjectValidation.date_of_expiry = false;
                    } else {
                        this.documentObjectValidation.date_issued = true;
                        this.documentObjectValidation.date_of_expiry = true;
                    }
                }
                if (this.documentObject.document_expiration_type_id) {
                    if (
                        this.documentObject.document_expiration_type_id == 1 ||
                        this.documentObject.document_expiration_type_id == 2
                    ) {
                        this.documentObject.date_of_expiry = this.addYearsToDate(
                            this.documentObject.document_expiration_type_id,
                        );
                    } else if (this.documentObject.document_expiration_type_id == 3) {
                        this.documentObject.date_of_expiry = this.addYearsToDate(5);
                    } else {
                        this.documentObject.date_of_expiry = null;
                    }
                }
            },
            deep: true,
        },
        'documentObject.date_of_expiry': {
            handler: function () {
                if (this.documentObject.date_issued != null && this.documentObject.date_of_expiry != null) {
                    const dateIssued = new Date(this.documentObject.date_issued);
                    const dateOfExpiry = new Date(this.documentObject.date_of_expiry);
                    if (dateIssued > dateOfExpiry) {
                        this.documentObjectValidation.date_issued = false;
                        this.documentObjectValidation.date_of_expiry = false;
                    } else {
                        this.documentObjectValidation.date_issued = true;
                        this.documentObjectValidation.date_of_expiry = true;
                    }
                }
            },
            deep: true,
        },
        'documentObject.document_expiration_type_id'(newVal) {
            if (newVal == 1 || newVal == 2) {
                this.documentObject.date_of_expiry = this.addYearsToDate(newVal);
            } else if (newVal == 3) {
                this.documentObject.date_of_expiry = this.addYearsToDate(5);
            } else {
                this.documentObject.date_of_expiry = null;
            }
        },
    },
    computed: {
        languages: {
            get() {
                return this.languagesItems;
            },
            set(newItem) {
                return newItem;
            },
        },
        existingSeafarer() {
            return this.$route.params.seafarerId != null;
        },
        level() {
            return this.levelString(this.languageObject.level);
        },
        isDateOfExpiryDisabled() {
            return (
                this.documentObject.document_expiration_type_id == null ||
                this.documentObject.document_expiration_type_id != 5
            );
        },
    },
    methods: {
        removeNavigation(index) {
            this.navigationItems.splice(index, 1);
        },
        removeDocument(index) {
            this.documentItems.splice(index, 1);
        },
        saveDocument() {
            let succes = true;
            if (this.documentObject.document_type_id == null || this.documentObject.document_type_id == '') {
                succes = false;
                this.documentObjectValidation.document_type_id = false;
            } else {
                this.documentObjectValidation.document_type_id = true;
            }
            if (this.documentObject.uploaded_file.name == null || this.documentObject.uploaded_file.name == '') {
                succes = false;
                this.$alert(this.$t('alerts.uploadFile'));
            }

            if (succes) {
                let date = new Date(this.documentObject.date_issued);
                this.documentObject.date_issued_display =
                    date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();

                date = new Date(this.documentObject.date_of_expiry);
                this.documentObject.date_of_expiry_display =
                    date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();

                this.documentItems.push(this.documentObject);
                this.documentObject = new ApplicationSeafarerDocument({});
                this.closeDocumentDialog();
            }
        },
        addYearsToDate(years) {
            const currentDate = new Date(this.documentObject.date_issued);
            currentDate.setFullYear(currentDate.getFullYear() + years);

            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
        closeDocumentDialog() {
            this.documentObject = new ApplicationSeafarerDocument({});
            this.documentObjectValidation = new ApplicationSeafarerDocument({}, true);
            this.addDocumentDialog = false;
        },
        addDocument() {
            this.addDocumentDialog = true;
        },
        loadExpiraitonTypes() {
            let vm = this;
            this.$APICall(
                'get',
                'web-application-document-expiration-types/' + this.$route.params.token,
                {},
                (data, succes) => {
                    if (succes) {
                        vm.documentExpirationTypes = data.items;
                        vm.expirationTypesLoaded = true;
                    }
                },
            );
        },
        reloadDocumentTypes() {
            let vm = this;
            this.$APICall(
                'get',
                'web-application-document-types-for-select/' + this.typeId + '/' + this.$route.params.token,
                {},
                (data, succes) => {
                    if (succes) {
                        vm.documentTypes = data;
                        vm.componentKey += 1;
                    }
                },
            );
        },
        saveNavigation() {
            let success = true;
            if (this.navigationObject.entity_name == null || this.navigationObject.entity_name == '') {
                success = false;
                this.navigationObjectValidation.entity_name = false;
            } else {
                this.navigationObjectValidation.entity_name = true;
            }
            if (
                this.navigationObject.maritime_object_name == null ||
                this.navigationObject.maritime_object_name == ''
            ) {
                success = false;
                this.navigationObjectValidation.maritime_object_name = false;
            } else {
                this.navigationObjectValidation.maritime_object_name = true;
            }
            if (this.navigationObject.rank_id == null || this.navigationObject.rank_id == '') {
                success = false;
                this.navigationObjectValidation.rank_id = false;
            } else {
                this.navigationObjectValidation.rank_id = true;
            }
            if (this.navigationObject.signed_on == null || this.navigationObject.signed_on == '') {
                success = false;
                this.navigationObjectValidation.signed_on = false;
            } else {
                this.navigationObjectValidation.signed_on = true;
            }
            if (this.navigationObject.signed_off == null || this.navigationObject.signed_off == '') {
                success = false;
                this.navigationObjectValidation.signed_off = false;
            } else {
                this.navigationObjectValidation.signed_off = true;
            }

            if (
                this.navigationObjectValidation.signed_on == false ||
                this.navigationObjectValidation.signed_off == false
            ) {
                success = false;
            }
            if (success) {
                this.navigationObject.seafarer_navigation_type_id = 2;
                let date = new Date(this.navigationObject.signed_on);
                this.navigationObject.signed_on_display =
                    date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();

                date = new Date(this.navigationObject.signed_off);
                this.navigationObject.signed_off_display =
                    date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();

                this.navigationItems.push(this.navigationObject);
                this.navigationObject = new ApplicationNavigation({});
                this.closeNavigationDialog();
            }
        },
        closeNavigationDialog() {
            this.navigationObject = new ApplicationNavigation({});
            this.navigationObjectValidation = new ApplicationNavigation({}, true);
            this.addNavigationDialog = false;
        },
        addNavigation() {
            this.addNavigationDialog = true;
        },
        calculateDuration() {
            if (this.navigationObject.signed_on != null && this.navigationObject.signed_off != null) {
                const signedOn = new Date(this.navigationObject.signed_on);
                const signedOff = new Date(this.navigationObject.signed_off);
                if (signedOn <= signedOff) {
                    var time_difference = signedOff.getTime() - signedOn.getTime();
                    var days_difference = time_difference / (1000 * 60 * 60 * 24);
                    this.navigationObject.duration = days_difference;
                    this.navigationObjectValidation.signed_on = true;
                    this.navigationObjectValidation.signed_off = true;
                } else {
                    this.navigationObjectValidation.signed_on = false;
                    this.navigationObjectValidation.signed_off = false;
                }
            }
        },
        removeEducation(index) {
            this.educationItems.splice(index, 1);
        },
        saveEducation() {
            let success = true;

            if (this.educationObject.school_name == '') {
                success = false;
                this.educationObjectValidation.school_name = false;
            } else {
                this.educationObjectValidation.school_name = true;
            }
            if (this.educationObject.date_from == null) {
                success = false;
                this.educationObjectValidation.date_from = false;
            } else {
                this.educationObjectValidation.date_from = true;
            }
            if (this.educationObject.date_to == null) {
                success = false;
                this.educationObjectValidation.date_to = false;
            } else {
                this.educationObjectValidation.date_to = true;
            }
            if (this.educationObject.date_from > this.educationObject.date_to) {
                success = false;
                this.educationObjectValidation.date_from = false;
                this.educationObjectValidation.date_to = false;
            }

            if (success) {
                let date = new Date(this.educationObject.date_from);
                this.educationObject.date_from_display =
                    date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();

                date = new Date(this.educationObject.date_to);
                this.educationObject.date_to_display =
                    date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();

                this.educationItems.push(this.educationObject);
                this.educationObject = new Education({});
                this.closeEducationDialog();
            }
        },
        closeEducationDialog() {
            this.addEducationDialog = false;
            this.educationObject = new Education({});
            this.educationObjectValidation = new Education({}, true);
        },
        addEducation() {
            this.addEducationDialog = true;
        },
        removeLanguage(index) {
            this.languages.splice(index, 1);
        },
        saveLanguage() {
            let success = true;

            if (this.languageObject.language_id == '' || this.languageObject.language_id == null) {
                success = false;
                this.languageObjectValidation.language_id = false;
            } else {
                this.languageObjectValidation.language_id = true;
            }
            this.languages.forEach((element) => {
                if (this.languageObject.language_id == element.language_id) {
                    success = false;
                    this.$alert(this.$t('alerts.languageAlreadyAdded'));
                }
            });
            if (this.languageObject.level == null) {
                this.$alert(this.$t('alerts.selectLevel'));
                success = false;
            }

            if (success) {
                this.languages.push(this.languageObject);
                this.languageObject = new ApplicationLanguage({});
                this.closeLanguageDialog();
            }
        },
        selectedRank(value) {
            this.navigationObject.rank_display = value.label;
        },
        selectedLanguage(value) {
            this.languageObject.language_display = value.label;
        },
        selectedCategory(value) {
            this.documentObject.document_type_display = value.label;
        },
        selectedType(value) {
            this.documentObject.document_name_display = value.label;
        },
        selectedCountry(value) {
            this.documentObject.issuing_country_display = value.label;
        },
        closeLanguageDialog() {
            this.languageObject = new ApplicationLanguage({});
            this.languageObjectValidation = new ApplicationLanguage({}, true);
            this.addLanguageDialog = false;
        },
        addLanguage() {
            this.addLanguageDialog = true;
        },
        clickFillOutFullApplication() {
            this.fillOutFullApplicationClicked = !this.fillOutFullApplicationClicked;
        },
        handleDropdownLoadError() {
            if (!this.showModal) {
                this.openModal(
                    'Link expiration date is ended. Please apply for a vacancy or an open application again.',
                );
            }
        },
        increaseUploadCounter() {
            this.uploadCounter++;
            if (this.uploadCounter > 5) {
                this.openModal(this.$t('alerts.uploadCountLimit'));
            }
        },
        openModal(text) {
            this.showModal = true;
            this.modalText = text;
            this.startCountdown();
        },
        startCountdown() {
            const countdownInterval = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(countdownInterval);
                    this.redirect();
                }
            }, 1000);
        },
        redirect() {
            window.location.href = 'https://www.azara.hr';
        },
        cancelClick() {
            this.canceling = true;
            this.redirect();
        },
        saveClick() {
            let success = true;
            let errorMessages = '';

            if (!this.existingSeafarer) {
                if (this.application.name === '') {
                    success = false;
                    this.applicationValidation.name = false;
                } else {
                    if (this.application.name.length > 50) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.name'))
                                .replace('%length%', '50') + '<br />';
                        this.applicationValidation.name = false;
                    } else {
                        this.applicationValidation.name = true;
                    }
                }

                if (this.application.surname === '') {
                    success = false;
                    this.applicationValidation.surname = false;
                } else {
                    if (this.application.surname.length > 50) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.surname'))
                                .replace('%length%', '50') + '<br />';
                        this.applicationValidation.surname = false;
                    } else {
                        this.applicationValidation.surname = true;
                    }
                }

                if (this.application.phone === '') {
                    success = false;
                    this.applicationValidation.phone = false;
                } else {
                    if (this.application.phone.length > 50) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.phone'))
                                .replace('%length%', '50') + '<br />';
                        this.applicationValidation.phone = false;
                    } else {
                        this.applicationValidation.phone = true;
                    }
                }

                if (this.application.seafarer_book === '') {
                    success = false;
                    this.applicationValidation.seafarer_book = false;
                } else {
                    if (this.application.seafarer_book.length > 50) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.seamanBook'))
                                .replace('%length%', '50') + '<br />';
                        this.applicationValidation.seafarer_book = false;
                    } else {
                        this.applicationValidation.seafarer_book = true;
                    }
                }

                if (!this.application.nationality_id) {
                    success = false;
                    this.applicationValidation.nationality_id = false;
                } else {
                    this.applicationValidation.nationality_id = true;
                }

                if (!this.application.rank_id) {
                    success = false;
                    this.applicationValidation.rank_id = false;
                } else {
                    this.applicationValidation.rank_id = true;
                }

                if (this.application.vessels.length == 0) {
                    success = false;
                    this.applicationValidation.vessels = false;
                } else {
                    this.applicationValidation.vessels = true;
                }

                if (!this.application.candidate_resume.upload_id) {
                    success = false;
                    errorMessages += this.$t('alerts.cvFileMissing') + '<br />';
                }
            }

            if (
                this.application.status_notes !== '' &&
                this.application.status_notes !== null &&
                this.application.status_notes.length > 1000
            ) {
                success = false;
                this.applicationValidation.status_notes = false;
                errorMessages +=
                    this.$t('alerts.lengthError')
                        .replace('%field%', this.$t('fields.notes'))
                        .replace('%length%', '1000') + '<br />';
            } else {
                this.applicationValidation.status_notes = true;
            }

            if (this.fillOutFullApplicationClicked) {
                if (!this.application.available_date || this.application.available_date == null) {
                    success = false;
                    this.applicationValidation.available_date = false;
                } else {
                    let dateNow = new Date();
                    let dateAvailable = new Date(this.application.available_date);

                    if (dateNow > dateAvailable) {
                        this.applicationValidation.available_date = false;
                        errorMessages += this.$t('alerts.availableDateOlderThanNow') + '<br/>';
                    } else {
                        this.applicationValidation.available_date = true;
                    }
                }

                if (!this.application.date_of_birth || this.application.date_of_birth == null) {
                    success = false;
                    this.applicationValidation.date_of_birth = false;
                } else {
                    let dateNow = new Date();
                    let dateOfBirth = new Date(this.application.date_of_birth);

                    if (dateNow < dateOfBirth) {
                        this.applicationValidation.date_of_birth = false;
                        errorMessages += this.$t('alerts.dateOfBirthDateOlder') + '<br/>';
                    } else {
                        this.applicationValidation.date_of_birth = true;
                    }
                }

                if (!this.application.country_of_residency_id || this.application.country_of_residency_id == null) {
                    success = false;
                    this.applicationValidation.country_of_residency_id = false;
                } else {
                    this.applicationValidation.country_of_residency_id = true;
                }

                if (this.application.place_of_birth === '') {
                    success = false;
                    this.applicationValidation.place_of_birth = false;
                } else {
                    if (this.application.place_of_birth.length > 100) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.placeOfBirth'))
                                .replace('%length%', '100') + '<br />';
                        this.applicationValidation.place_of_birth = false;
                    } else {
                        this.applicationValidation.place_of_birth = true;
                    }
                }

                if (!this.application.gender_id || this.application.gender_id == null) {
                    success = false;
                    this.applicationValidation.gender_id = false;
                } else {
                    this.applicationValidation.gender_id = true;
                }

                if (!this.application.marital_status_id || this.application.marital_status_id == null) {
                    success = false;
                    this.applicationValidation.marital_status_id = false;
                } else {
                    this.applicationValidation.marital_status_id = true;
                }

                if (!this.application.account_currency_id || this.application.account_currency_id == null) {
                    success = false;
                    this.applicationValidation.account_currency_id = false;
                } else {
                    this.applicationValidation.account_currency_id = true;
                }

                if (this.application.street_name_and_number === '') {
                    success = false;
                    this.applicationValidation.street_name_and_number = false;
                } else {
                    if (this.application.street_name_and_number.length > 250) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.streetNameAndNumber'))
                                .replace('%length%', '250') + '<br />';
                        this.applicationValidation.street_name_and_number = false;
                    } else {
                        this.applicationValidation.street_name_and_number = true;
                    }
                }

                if (this.application.city === '') {
                    success = false;
                    this.applicationValidation.city = false;
                } else {
                    if (this.application.city.length > 100) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.city'))
                                .replace('%length%', '100') + '<br />';
                        this.applicationValidation.city = false;
                    } else {
                        this.applicationValidation.city = true;
                    }
                }

                if (this.application.post_code === '') {
                    success = false;
                    this.applicationValidation.post_code = false;
                } else {
                    if (this.application.post_code.length > 50) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.postCode'))
                                .replace('%length%', '50') + '<br />';
                        this.applicationValidation.post_code = false;
                    } else {
                        this.applicationValidation.post_code = true;
                    }
                }

                if (!this.application.country_id || this.application.country_id == null) {
                    success = false;
                    this.applicationValidation.country_id = false;
                } else {
                    this.applicationValidation.country_id = true;
                }

                if (!this.application.airport_id || this.application.airport_id == null) {
                    success = false;
                    this.applicationValidation.airport_id = false;
                } else {
                    this.applicationValidation.airport_id = true;
                }

                if (this.application.emergency_contact_name === '') {
                    success = false;
                    this.applicationValidation.emergency_contact_name = false;
                } else {
                    if (this.application.emergency_contact_name.length > 250) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.emergencyContactName'))
                                .replace('%length%', '250') + '<br />';
                        this.applicationValidation.emergency_contact_name = false;
                    } else {
                        this.applicationValidation.emergency_contact_name = true;
                    }
                }

                if (
                    !this.application.emergency_contact_relationship_id ||
                    this.application.emergency_contact_relationship_id == null
                ) {
                    success = false;
                    this.applicationValidation.emergency_contact_relationship_id = false;
                } else {
                    this.applicationValidation.emergency_contact_relationship_id = true;
                }

                if (this.application.emergency_contact_street_name_and_number === '') {
                    success = false;
                    this.applicationValidation.emergency_contact_street_name_and_number = false;
                } else {
                    if (this.application.emergency_contact_street_name_and_number.length > 250) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.emergencyContactStreetNameAndNumber'))
                                .replace('%length%', '250') + '<br />';
                        this.applicationValidation.emergency_contact_street_name_and_number = false;
                    } else {
                        this.applicationValidation.emergency_contact_street_name_and_number = true;
                    }
                }

                if (this.application.emergency_contact_city === '') {
                    success = false;
                    this.applicationValidation.emergency_contact_city = false;
                } else {
                    if (this.application.emergency_contact_city.length > 250) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.emergencyContactCity'))
                                .replace('%length%', '250') + '<br />';
                        this.applicationValidation.emergency_contact_city = false;
                    } else {
                        this.applicationValidation.emergency_contact_city = true;
                    }
                }

                if (this.application.emergency_contact_post_code === '') {
                    success = false;
                    this.applicationValidation.emergency_contact_post_code = false;
                } else {
                    if (this.application.emergency_contact_post_code.length > 250) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.emergencyContactPostCode'))
                                .replace('%length%', '250') + '<br />';
                        this.applicationValidation.emergency_contact_post_code = false;
                    } else {
                        this.applicationValidation.emergency_contact_post_code = true;
                    }
                }

                if (
                    !this.application.emergency_contact_country_id ||
                    this.application.emergency_contact_country_id == null
                ) {
                    success = false;
                    this.applicationValidation.emergency_contact_country_id = false;
                } else {
                    this.applicationValidation.emergency_contact_country_id = true;
                }

                if (this.application.contact_number === '') {
                    success = false;
                    this.applicationValidation.contact_number = false;
                } else {
                    if (this.application.contact_number.length > 50) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.emergencyContactNumber'))
                                .replace('%length%', '50') + '<br />';
                        this.applicationValidation.contact_number = false;
                    } else {
                        this.applicationValidation.contact_number = true;
                    }
                }

                if (this.application.contact_email === '') {
                    success = false;
                    this.applicationValidation.contact_email = false;
                } else {
                    if (this.application.contact_email.length > 100) {
                        errorMessages +=
                            this.$t('alerts.lengthError')
                                .replace('%field%', this.$t('fields.emergencyContactEmail'))
                                .replace('%length%', '100') + '<br />';
                        this.applicationValidation.contact_email = false;
                    } else {
                        this.applicationValidation.contact_email = true;
                    }
                }
            }

            if (errorMessages !== '') {
                this.$alert(errorMessages);
                success = false;
            }

            if (success) {
                if (this.existingSeafarer) {
                    this.application.seafarer_id = this.$route.params.seafarerId;
                } else {
                    this.application.full_application = this.fillOutFullApplicationClicked;
                    this.application.languages = this.languagesItems;
                    this.application.education = this.educationItems;
                    this.application.navigation = this.navigationItems;
                    this.application.documents = this.documentItems;
                }
                let addition = this.$route.params.token + '/' + this.$route.params.vacancyId;
                if (this.fillOutFullApplicationClicked == false) {
                    if (this.existingSeafarer) {
                        this.$verifyShortFormExisting(this.$t('alerts.shortFormExistingVerify'), (result) => {
                            if (result) {
                                this.saving = true;
                                this.$APICall(
                                    'post',
                                    'web-application-submit-vacancy/' + addition,
                                    this.application,
                                    (data, success) => {
                                        if (success) {
                                            this.openModal(this.$t('texts.submitSuccesText'));
                                        } else {
                                            this.$alert(this.$t('alerts.basicError'));
                                        }
                                        this.saving = false;
                                    },
                                    false,
                                );
                            }
                        });
                    } else {
                        this.$verifyShortForm(this.$t('alerts.shortFormVerify'), (result) => {
                            if (result) {
                                this.saving = true;
                                this.$APICall(
                                    'post',
                                    'web-application-submit-vacancy/' + addition,
                                    this.application,
                                    (data, success) => {
                                        if (success) {
                                            this.openModal(this.$t('texts.submitSuccesText'));
                                        } else {
                                            this.$alert(this.$t('alerts.basicError'));
                                        }
                                        this.saving = false;
                                    },
                                    false,
                                );
                            }
                        });
                    }
                } else {
                    this.saving = true;
                    this.$APICall(
                        'post',
                        'web-application-submit-vacancy/' + addition,
                        this.application,
                        (data, success) => {
                            if (success) {
                                this.openModal(this.$t('texts.submitSuccesText'));
                            } else {
                                this.$alert(this.$t('alerts.basicError'));
                            }
                            this.saving = false;
                        },
                        false,
                    );
                }
            } else {
                this.$alert(this.$t('alerts.fillOutRequiredFields'));
            }
        },
        levelString(level) {
            if (level == 1) {
                return this.$t('fields.noProfficiency');
            } else if (level == 2) {
                return this.$t('fields.poor');
            } else if (level == 3) {
                return this.$t('fields.good');
            } else if (level == 4) {
                return this.$t('fields.fluent');
            } else {
                return '';
            }
        },
        loadVacancy() {
            this.$APICall(
                'get',
                'web-application-vacancy/' + this.$route.params.vacancyId,
                {},
                (data, success) => {
                    if (success) {
                        this.rank = data.rank;
                    } else {
                        if (Object.hasOwn(data, 'custom')) {
                            this.openModal(data.message);
                        } else {
                            this.$alert(this.$t('alerts.basicError'));
                        }
                    }
                },
                false,
            );
        },
        loadSeafarer() {
            this.$APICall(
                'get',
                'web-application-seafarer/' + this.$route.params.seafarerId,
                {},
                (data, success) => {
                    if (success) {
                        this.application = data.object;
                        this.application.status_notes = '';
                        this.application.application_status_id = 1;
                        this.application.web_application = 1;
                        this.application.seafarer_id = data.object.id;
                        this.application.vacancy_id = this.$route.params.vacancyId;
                        this.application.vessels = [];
                    } else {
                        this.$alert(this.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        linkVerification() {
            this.$APICall(
                'get',
                'web-application-link-verification/' + this.$route.params.token,
                {},
                (data, success) => {
                    if (success) {
                        this.isVerified = true;
                        this.application.email = data.email;
                        this.uploadCounter = data.upload_counter;
                        if (this.uploadCounter > 5) {
                            this.openModal(this.$t('alerts.uploadCountLimit'));
                        }
                    } else {
                        this.openModal(data.message);
                    }
                },
                false,
            );
        },
    },

    mounted() {
        this.linkVerification();
        this.loadVacancy();
        if (this.existingSeafarer) {
            this.loadSeafarer();
        }
    },
};
</script>

<style scoped>
.text {
    color: rgba(5, 75, 97, 255);
}

.headings-font {
    font-family: 'Maitree-Regular', sans-serif !important;
}

.headings-font-weight {
    font-weight: 600;
}

.buttons-font {
    font-family: 'Nunito-Regular', sans-serif !important;
}

.rank-font-weight {
    font-weight: 1000;
}

.description-font {
    font-family: 'Nunito-Regular', sans-serif !important;
}

.submit-text {
    font-weight: 600;
    font-size: 18px;
}

.redirecting-text {
    font-weight: 400;
    font-size: 14px;
}

>>> .v-input {
    background-color: white;
}
</style>
